import { Gauge, ShieldCheck, ClipboardList, Leaf, TrendingUp } from "lucide-react";
import { Reveal, SectionHead } from "../components/ui-bits";

const FOCUS = [
  { icon: Gauge, label: "Convenience" },
  { icon: ShieldCheck, label: "Trust" },
  { icon: ClipboardList, label: "Standardization" },
  { icon: Leaf, label: "Sustainability" },
  { icon: TrendingUp, label: "Scalability" },
];

export default function About() {
  return (
    <section id="about" className="relative py-20 lg:py-28" data-testid="about-section">
      <div className="container-x">
        <div className="max-w-3xl">
            <SectionHead
              eyebrow="About Carza"
              title={<>Technology Meets Car Care.</>}
            />
            <Reveal delay={0.15} className="mt-6 flex flex-col gap-4 text-[15px] leading-relaxed text-mist">
              <p>
                CARZA is building a modern car-care ecosystem that combines technology, trained service partners and resource-efficient vehicle-care processes. We started with a simple observation: car ownership in India keeps rising, but the way cars are cared for hasn't materially changed in decades.
              </p>
              <p>
                Our answer is an operating system for car care — digital booking and tracking on one side, a network of trained and verified service partners on the other, connected by standardized processes that make quality repeatable. Water efficiency is engineered into the process itself, not added on.
              </p>
            </Reveal>
            <Reveal delay={0.25} className="mt-8">
              <div className="flex flex-wrap gap-2.5">
                {FOCUS.map((f) => (
                  <span key={f.label} className="flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-[13px] font-medium text-paper" data-testid={`about-focus-${f.label.toLowerCase()}`}>
                    <f.icon size={13} className="text-carza" /> {f.label}
                  </span>
                ))}
              </div>
            </Reveal>
        </div>
      </div>
    </section>
  );
}
